import { useEffect, useState } from "react";

const stats = [
  { icon: "ri-award-line", label: "Licensed Agents", value: "Certified" },
  { icon: "ri-time-line", label: "Support", value: "24/7" },
  { icon: "ri-file-list-3-line", label: "Plans Available", value: "100+" },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3ab486c3eac91d1e6794cf9952aa84a6.jpg"
          alt="East Texas family protected by health insurance"
          title="HealthMarkets Insurance Agency - Family Health Insurance Irving TX"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/90 via-emerald-900/75 to-emerald-800/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 border border-white/30 text-white text-sm font-['Open_Sans'] mb-8 transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
            Open 24/7 &nbsp;•&nbsp; Irving, TX &nbsp;•&nbsp; 972-217-4662
          </div>

          {/* Headline */}
          <h2
            className={`font-['Poppins'] font-800 text-5xl lg:text-6xl text-white leading-tight mb-6 transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            Your Health,<br />
            <strong className="text-amber-400">Our Priority</strong>
          </h2>

          {/* Subheadline */}
          <p
            className={`font-['Open_Sans'] text-lg text-white/85 leading-relaxed mb-10 max-w-xl transition-all duration-700 delay-300 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            Personalized <strong>private health insurance</strong> solutions tailored to your family's needs. 
            Our <strong>licensed agents in Irving, TX</strong> are ready around the clock to find your perfect coverage.
          </p>

          {/* CTA Buttons */}
          <div
            className={`flex flex-wrap gap-4 mb-12 transition-all duration-700 delay-500 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <button
              onClick={() => handleScroll("plans")}
              className="px-8 py-4 bg-amber-500 hover:bg-amber-400 text-white font-['Poppins'] font-600 rounded-lg flex items-center gap-2 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Plans
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => handleScroll("contact")}
              className="px-8 py-4 border-2 border-white/60 hover:border-white text-white font-['Poppins'] font-600 rounded-lg flex items-center gap-2 transition-all duration-200 whitespace-nowrap cursor-pointer hover:bg-white/10"
            >
              <i className="ri-calendar-line"></i>
              Schedule Consultation
            </button>
          </div>

          {/* Stats */}
          <div
            className={`flex flex-wrap gap-6 transition-all duration-700 delay-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            {stats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-white/15 border border-white/25 flex items-center justify-center">
                  <i className={`${stat.icon} text-amber-400 text-lg`}></i>
                </div>
                <div>
                  <div className="font-['Poppins'] font-700 text-white text-base">{stat.value}</div>
                  <div className="font-['Open_Sans'] text-white/70 text-xs">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce cursor-pointer" onClick={() => handleScroll("about")}>
        <div className="w-8 h-12 rounded-full border-2 border-white/40 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
